// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"37":"479c7b1b","514":"9218e660","819":"5cb11188"}[chunkId] + ".css";
};